import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { SelectionProvider } from './context/SelectionContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SimplifiedHome } from './pages/SimplifiedHome';
import { CookieConsentBanner } from './components/CookieConsentBanner';
import { ToolDetailPage } from './components/ToolDetailPage';
import { CategoryPage } from './components/CategoryPage';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

// Wrap the entire app in an error boundary with a try-catch
function App() {
  try {
    return (
      <ErrorBoundary>
        <HelmetProvider>
          <ThemeProvider>
            <SelectionProvider>
              <Router>
                <div className="flex flex-col min-h-screen">
                  <Header />
                  <main className="flex-grow">
                    <Routes>
                      <Route path="/" element={<SimplifiedHome />} />
                      <Route path="/tool/:toolId" element={<ToolDetailPage />} />
                      <Route path="/category/:categoryId" element={<CategoryPage />} />
                      <Route path="/category/:categoryId/:subcategoryId" element={<CategoryPage />} />
                    </Routes>
                  </main>
                  <Footer />
                  <CookieConsentBanner />
                </div>
              </Router>
            </SelectionProvider>
          </ThemeProvider>
        </HelmetProvider>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error('Critical error in App component:', error);
    return (
      <div className="p-6 bg-red-50 border border-red-200 rounded-lg my-4">
        <h2 className="text-lg font-semibold text-red-800 mb-2">Application Error</h2>
        <p className="text-red-700 mb-4">
          We encountered a critical error while loading the application.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md text-sm"
        >
          Reload Application
        </button>
      </div>
    );
  }
}

export default App;